module.exports = __webpack_public_path__ + "assets/CashReconciliation.cff7d622.svg";